import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchProjectStatuses({ data }) {

  try {
    const response = yield axios.get(`${baseURL}/project_status`, {
    });
    if (response.status === 200) {
      yield put(actions.fetchProjectStatusesSuccess(response.data));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchProjectStatusesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateProjectStatuses({ data }) {
  const { color, id, showByDefault, statusName } = data;
  try {
    const response = yield axios.patch(
      `${baseURL}/project_status/${id}`,
      {
        showByDefault,
        statusName,
        color,
      }
    );
    if (response.status === 200) {
      AntdAlert.success("Project Status Updated Successfully");
      yield put(actions.updateProjectStatusesSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateProjectStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectStatusesError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteProjectStatuses({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/project_status/${id}`
    );

    if (response.status === 200) {
      AntdAlert.success("Project Status Deleted Successfully");
      yield put(actions.deleteProjectStatusesSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteProjectStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteProjectStatusesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateProjectStatuses({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    const response = yield axios.post(`${baseURL}/project_status`, {
      ...newData,
    });
    if (response.status === 201) {
      AntdAlert.success("Project Status Created Successfully");
      yield put(actions.createProjectStatusesSuccess(response.data));
      console.log(response.data);
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createProjectStatusesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateProjectOrder({ data }) {
  const projectStatusObj = {};

  data.forEach((el, i) => {
    projectStatusObj[el.id] = i;
  });

  const payload = {
    projectStatus: projectStatusObj
  };
  try {
    const response = yield axios.post(
      `${baseURL}/project_status/sort`,
      payload
    );

    if (response.status === 201) {
      AntdAlert.success("Project Status Order Updated Successfully");
      yield put(actions.updateProjectsOrderSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateProjectsOrderError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateProjectsOrderError());
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}
